<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Hidden Mision" class="mb-3" />
      </b-col>
    </b-row>
    <b-media>
      <section class="py-3">
        <b-row>
          <b-col cols="10">
            <h2 class="mb-2">Hidden Mision</h2>
          </b-col>
        </b-row>
      </section>
    </b-media>
    <b-card>
      <quest-hidden-table @getList="getList" :hidden_quests="hidden_quests" />
    </b-card>
    <b-pagination
      class="mt-auto"
      pills
      size="lg"
      align="center"
      v-model="current_page"
      :total-rows="total_items"
      :per-page="items_perpage"
    />
  </div>
</template>

<script>
import service from "../service";
import QuestHiddenTable from "./_components/QuestHiddenTable.vue";
export default {
  components: {
    QuestHiddenTable,
  },
  data() {
    return {
      current_page: 1,
      total_items: 0,
      items_perpage: 50,
      hidden_quests: [],
      editLanguage: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let response = await service.getList({
        page: this.current_page,
        limit: this.items_perpage,
      });
      if (response.data.type === "DATA") {
        this.hidden_quests = response.data.data.list;
        this.total_items = response.data.data.total;
      }
    },
  },
};
</script>
